import * as React from 'react';
import './header.scss';
import Menu, { SubMenu, Item as MenuItem } from 'rc-menu';
import 'rc-menu/assets/index.css';
import animate from 'css-animation';
import { getAdminConfigTableItem } from '../_global/utility/adminConfigUtils';
export interface NavSubMenu {
  children: Array<any>;
  customUrl: string;
  expanded: boolean;
  isHeading: boolean;
  newTab: boolean;
  protocol: string;
  route: string;
  title: string;
} 
interface NavMenuItem {
  customUrl: string;
  isHeading: boolean;
  newTab: boolean;
  protocol: string;
  route: string;
  title: string;
} 
function handleClick(info: any) {
  console.log(`clicked ${info.key}`);
  console.log(info);
}

const animation = {
  enter(node: any, done: any) {
    let height;
    return animate(node, 'rc-menu-collapse', {
      start() {
        height = node.offsetHeight;
        node.style.height = 0;
      },
      active() {
        node.style.height = `${height}px`;
      },
      end() {
        node.style.height = '';
        done();
      },
    });
  },

  appear() {
    return this.enter.apply(this, arguments);
  },

  leave(node: any, done: any) {
    return animate(node, 'rc-menu-collapse', {
      start() {
        node.style.height = `${node.offsetHeight}px`;
      },
      active() {
        node.style.height = 0;
      },
      end() {
        node.style.height = '';
        done();
      },
    });
  },
};

export interface HeaderNavProps {
  mode?: 'inline' | 'horizontal' | 'vertical' | 'vertical-left' | 'vertical-right' | undefined;
  openAnimation?: string | object;
  triggerSubMenuAction?: string;
  defaultOpenKeys?: [string];
  updateChildrenAndOverflowedIndicator?: boolean;
  clientConfig: any;
  adminConfig: any;
}
export class HeaderNav extends React.Component<HeaderNavProps> {
  state = {
    overflowedIndicator: undefined,
  };

  render() {
    const { overflowedIndicator } = this.state;
    let pageHeaderAdminData = getAdminConfigTableItem(
      this.props.adminConfig,
      this.props.clientConfig,
      'PageHeader',
      this.props.clientConfig.clientConfig.magCode,
    );
    let navMenu: any = [];
    let subMenuKey = 1;
    let menuItemKey = 0;
    if (pageHeaderAdminData.Navigation !== undefined) {
      pageHeaderAdminData.Navigation.forEach((navItem: NavSubMenu) => {
     
        navMenu.push(
          <SubMenu
            key={subMenuKey}
            title={<span className="submenu-title-wrapper">{navItem.customUrl ? <a href={navItem.protocol + navItem.customUrl} 
            target={navItem.newTab ? '_blank' : ''}>{navItem.title}</a> : navItem.title}</span>} 
          >
  
          {navItem.children !== undefined &&  (
            navItem.children.map((childItem: NavMenuItem) => {
              menuItemKey++;
              return <MenuItem key={subMenuKey + '-' + menuItemKey}  title={childItem.title}>
              {childItem.customUrl ? <a href={childItem.protocol + childItem.customUrl} target={childItem.newTab ? '_blank' : ''}>
              <span className="submenu-title-wrapper">{childItem.title}</span></a> : childItem.title}
              </MenuItem> ;
            })
          )}
          </SubMenu>,
        );
        subMenuKey++;
        menuItemKey = 0;
      });
    }

    return (
      <div>
        <Menu
          // onClick={handleClick}
          triggerSubMenuAction={'hover'}
          // onOpenChange={onOpenChange}
          // selectedKeys={['1']}
          mode={this.props.mode}
          openAnimation={animation}
          overflowedIndicator={overflowedIndicator}
          className={'rc-menu'}
        >

        {navMenu}
        </Menu>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/app/header/HeaderNav.tsx